import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import TaskIconDictionary from '@components/FormFlow/Util/TaskIconDictionary';
import { LocalStorageKeys } from '@containers/App';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Col, Row } from 'antd';
import React from 'react';

import MenuComponentItem from './MenuComponentItem';


interface IMenuComponentProp {
  onClickComponent: Function;
  onMouseOverMenu: Function;
  activeTooltip: string;
};

export default class MenuComponent extends React.Component<IMenuComponentProp> {
  handleMenuMouseOver = (tooltipText: string) => {
    this.props.onMouseOverMenu(tooltipText)
  }

  render() {
    const {
      onClickComponent
    } = this.props;
    return (
      <LateralMenuWrapper>
        <FormflowContext.Consumer>
          {({ currentSection }) => (
            <Row className="row">
              <Col className="lateralComponentsMenu" style={{ height: "100%" }}>
                <MenuComponentItem
                  title={I18n.l('formflow.components.confirmComponent.titleConfirmComponent')}
                  icon={TaskIconDictionary.get(ComponentType.CONFIRM) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.CONFIRM)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Yes/No'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.textComponent.titleTextComponent')}
                  icon={TaskIconDictionary.get(ComponentType.TEXT) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.TEXT)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Text'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.photoComponent.titlePhotoComponent')}
                  icon={TaskIconDictionary.get(ComponentType.PHOTO) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.PHOTO)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Photo'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.numberComponent.titleNumberComponent')}
                  icon={TaskIconDictionary.get(ComponentType.NUMBER) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.NUMBER)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Number'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.dateComponent.titleDateComponent')}
                  icon={TaskIconDictionary.get(ComponentType.DATE) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.DATE)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Date'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.gpsComponent.titleGPSComponent')}
                  icon={TaskIconDictionary.get(ComponentType.GPS) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.GPS)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='GPS'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.audioComponent.titleAudioComponent')}
                  icon={TaskIconDictionary.get(ComponentType.AUDIO) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.AUDIO)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Audio'
                />

                <MenuComponentItem
                  title={I18n.l('formflow.components.modelComponent.titleModelComponent')}
                  icon={TaskIconDictionary.get(ComponentType.MODEL) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.MODEL)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Model'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.phraseComponent.titlePhraseComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SAMPLETEXT) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.SAMPLETEXT)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='SAMPLETEXT'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.imageComponent.titleImageComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SAMPLEIMAGE) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.SAMPLEIMAGE)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='SAMPLEIMAGE'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.sampleVideo.titleSampleVideoComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SAMPLEVIDEO) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.SAMPLEVIDEO)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='SAMPLEVIDEO'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.selectComponent.titleDateComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SELECT) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.SELECT)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Select'
                />

                <MenuComponentItem
                  title={I18n.l('formflow.components.sumComponent.titleSumComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SCORE) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.SCORE)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Score'
                />

                <MenuComponentItem
                  title={I18n.l('formflow.components.goToComponent.titleGoToComponent')}
                  icon={TaskIconDictionary.get(ComponentType.GOTO) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.GOTO)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='TODO'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.sampleComponent.titleSampleComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SAMPLE) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.SAMPLE)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Sample'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.calculatorComponent.title')}
                  icon={TaskIconDictionary.get(ComponentType.CALCULATOR) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.CALCULATOR)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Calculator'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.drawComponent.titleDrawComponent')}
                  icon={TaskIconDictionary.get(ComponentType.DRAW) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.DRAW)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='Draw'
                />
                <MenuComponentItem
                  title={I18n.l('QRCODE')}
                  icon={TaskIconDictionary.get(ComponentType.QRCODE) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.QRCODE)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='QRCode'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.fileUpload.title')}
                  icon={TaskIconDictionary.get(ComponentType.FILEUPLOAD) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.FILEUPLOAD)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='FileUpload'
                />
                <MenuComponentItem
                  title={I18n.l('formflow.components.imageRecognition.title')}
                  icon={TaskIconDictionary.get(ComponentType.IMAGERECOGNITION) as IconProp}
                  onClickComponent={() => onClickComponent(ComponentType.IMAGERECOGNITION)}
                  activeTooltip={this.props.activeTooltip}
                  handleMenuMouseOver={this.handleMenuMouseOver}
                  tooltipText='ImageRecognition'
                />

              </Col>
            </Row>
          )}
        </FormflowContext.Consumer>
      </LateralMenuWrapper >
    )
  }
}

const LateralMenuWrapper = styled.div`
          
`